import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import styles from './log_search_input.module.css';
import { getLogger } from '../../services/logger.service';

import 'react-datepicker/dist/react-datepicker.css';

const log = getLogger('LogSearchInput');
// TODO: this file is not working
import './custom-react-datepicker.css';

import searchStore from '../../stores/search.store';
import { observer } from 'mobx-react';
import AsyncSelect from 'react-select/async';
import { components, ActionMeta, GroupBase, MenuListProps, MultiValue, StylesConfig } from 'react-select';
import { SearchType, CustomOption, searchParamTitle, SearchParam, SearchMeta } from '../../models/search.model';
import ParamService, { ParamsObjectArray } from '../../services/param.service';
import DatePicker from 'react-datepicker';
import Highlighter from 'react-highlight-words';

// the module augmentation below is only applied if the module is part of the compilation
import type {} from 'react-select/base';

declare module 'react-select/base' {
  export interface Props<Option, IsMulti extends boolean, Group extends GroupBase<Option>> {
    currentParam?: SearchType;
  }
}

interface State {
  inputValue: string;
  value: CustomOption[];
  currentType?: SearchType;
  open: boolean;
  selectedDate: Date; 
}

const MenuList = (props: MenuListProps<CustomOption, true>) => {
  const {currentParam} = props.selectProps;
  log.d('the value', props.getValue());
  let title = 'Search ';
  title += currentParam ? searchParamTitle(currentParam) :  'Parameter';
  const supportsNegation = currentParam
    && currentParam !== SearchParam.FROM_TIME
    && currentParam !== SearchParam.TO_TIME
    && currentParam !== SearchParam.REGEX
    && currentParam !== SearchParam.LINE_NUMBER;
  const supportsComparison = currentParam === SearchParam.APP_VERSION || currentParam === SearchParam.OS_VERSION;
  return (
    <components.MenuList {...props}>
      <div className={styles.menuTitle}>{title}</div>
      {supportsNegation && <div className={styles.menuHint}>Prefix with ! or - to exclude{supportsComparison ? ', or use >, <, >=, <= to compare versions' : ''}</div>}
      {props.children}
    </components.MenuList>
  );
};

const customStyles: StylesConfig<CustomOption, true> = {
  control: (base, _state) => ({
    ...base,
    '&:hover': { borderColor: 'gray' }, // border style on hover
    border: '1px solid var(--bb-grey)', // default border color
    borderRadius: 0
    // You can also use state.isFocused to conditionally style based on the focus state
  }),
  placeholder: (base, _state) => ({
    ...base,
    color: 'var(--pinkish-grey)',
  }),
  option: (base, state) =>  ({
    ...base,
    color: 'var(--marine)',
    padding: '4px 14px',
    fontSize: 15,
    fontWeight: 300,
    backgroundColor: state.isFocused ? 'rgba(33, 161, 181, .1)' : undefined,
    ':active': {
      backgroundColor: 'rgba(33, 161, 181, .2)',
    }
  }),
  menu: (base, state) => ({
    ...base,
    boxShadow: '0 0 7px rgba(0, 0, 0, .2)',
    marginTop: 15
  }),
  multiValue: (base, state) => ({
    ...base,
    backgroundColor: 'var(--fully-white)',
    border: '1px solid var(--marigold)',
    borderRadius: 4,
  }),
  multiValueLabel: (base, state) => ({
    ...base,
    color: 'var(--marine)',
    fontSize: 12,
    padding: 4
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: 'var(--marine)',
    '&:hover': { 
      backgroundColor: 'var(--marigold)',
      color: 'var(--marine)'
    }
  })
};
class LogSearchInput extends React.Component<RouteComponentProps<{}>, State> {
  constructor(props: RouteComponentProps<{}>) {
    super(props);
    
    this.state = {
      inputValue: '',
      value: [],
      open: false, 
      selectedDate: new Date()
    };
    this.getOptions = this.getOptions.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.formatOptionLabel = this.formatOptionLabel.bind(this);
    this.split = this.split.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
  }
  
  private split(value: string) {
    let split = value.split(':');
    split = [split.shift()!!, split.join(':')];
    return split;
  }

  private handleChange(selectedOptions: MultiValue<CustomOption>, _action: ActionMeta<CustomOption>) {
    log.d('the selectedOptions:' , selectedOptions);
    const params: ParamsObjectArray = {};

    if (selectedOptions.length === 0 && searchStore.selectedOptions.length === 0) return;

    selectedOptions.forEach(option => {
      const type = option.type;
      if (option.value.length > 0) {
        const value = option.value.trim();
        if (params[type]) params[type].push(value);
        else params[type] = [value];
      }
      else {
        log.v('intermediate');
        const open = type === SearchParam.FROM_TIME || type === SearchParam.TO_TIME;
        this.setState({inputValue: `${type}:`, currentType: type, open});
      }
    });

    const hasEmptyValue = selectedOptions.some(option => option.value.length === 0);
    if (hasEmptyValue) return;

    if (searchStore.range) params[SearchMeta.RANGE] = [searchStore.range];
    if (searchStore.minSeverity) params[SearchMeta.MIN_SEVERITY] = [searchStore.minSeverity];
    else if (searchStore.severity?.length) params[SearchMeta.SEVERITY] = searchStore.severity;

    if (searchStore.isAlert) searchStore.setParams(params)
    else ParamService.setParams(this.props, params, true);
  }

  private formatOptionLabel(option: CustomOption) {
    log.d('option', option);
    const word = option.value.length > 0 ? this.split(this.state.inputValue)[1] : this.state.inputValue;
    const isTimeChip = option.value.length > 0
      && (option.type === SearchParam.FROM_TIME || option.type === SearchParam.TO_TIME);
    const onClick = isTimeChip
      ? (e: React.MouseEvent) => {
          e.stopPropagation();
          const parsed = new Date(option.value);
          this.setState({
            currentType: option.type,
            selectedDate: isNaN(parsed.getTime()) ? new Date() : parsed,
            open: true,
          });
        }
      : undefined;
    return (
      <div onClick={onClick} className={isTimeChip ? styles.timeChipLabel : undefined}>
        <Highlighter highlightTag="strong"
          autoEscape
          searchWords={[word]}
          textToHighlight={option.label}/>
      </div>
    );

  }
  private async getOptions(input: string ) {
    log.v('getOptions');
    let options: CustomOption[];
    if (this.state.currentType) {
      const [, value] = this.split(input);
      const values = await searchStore.search(this.state.currentType, value.trim());
      options = values.map(val => {
        return {value: val, label: val, type: this.state.currentType!}; 
      });
    }
    else {
      options = searchStore.searchParams.filter(param => 
        param.label.toLocaleLowerCase().includes(input.toLocaleLowerCase()));
    }
    return options;
  }

  onInputChange(inputValue: string) {
    if (this.state.open) return;
    log.v('onInputChange input value', inputValue); 
    const [type, value] = this.split(inputValue);
    const currentType = value.length > 0 ? type as SearchType : undefined;
    log.v('onInputChange', currentType);

    // only if closed checking if should open
    const open = currentType === SearchParam.FROM_TIME || currentType === SearchParam.TO_TIME;
    this.setState({inputValue, currentType, open});
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDateChange(date: Date, event?: React.SyntheticEvent<any>) {
    if (event) {
      this.setState({selectedDate: date});
      return;
    }
    log.d('date change', event);
    const { currentType } = this.state;
    ParamService.setParam(this.props, currentType!, date.toISOString());
    this.setState({open: false, inputValue: '', selectedDate: date});
    log.d('date change', date);
  }

  render() {
    const {selectedOptions, searchParams: searchParameters} = searchStore;
    const {open, selectedDate} = this.state;
    return (
      <div className={styles.component}>
        <AsyncSelect
          styles={customStyles}
          onInputChange={this.onInputChange}
          inputValue={this.state.inputValue}
          value={selectedOptions}
          placeholder="Search - case sensitive"
          onChange={this.handleChange}
          formatOptionLabel={this.formatOptionLabel}
          components={{
            DropdownIndicator: null,
            MenuList
          }}
          loadOptions={this.getOptions}
          defaultOptions={searchParameters}
          isMulti
          currentParam={this.state.currentType} // passing it for the menu list
          />
          <DatePicker
            selected={selectedDate}
            onChange={this.onDateChange}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={15}
            maxDate={new Date()}
            open={open}
            onClickOutside={() => this.setState({open: false})}
            customInput={<input style={{display: 'none'}} />}
            />
      </div>
    );
  }
}

export default withRouter(observer(LogSearchInput));